import { render, staticRenderFns } from "./PreferenceInventory.vue?vue&type=template&id=f890f1c6&"
import script from "./PreferenceInventory.vue?vue&type=script&lang=ts&"
export * from "./PreferenceInventory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f890f1c6')) {
      api.createRecord('f890f1c6', component.options)
    } else {
      api.reload('f890f1c6', component.options)
    }
    module.hot.accept("./PreferenceInventory.vue?vue&type=template&id=f890f1c6&", function () {
      api.rerender('f890f1c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Preference/PreferenceInventory.vue"
export default component.exports